module.exports = __webpack_public_path__ + "img/login.74b8138b.svg";